export default "__VITE_ASSET__BksptvRz__"